import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function injectPerfHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  const links: Array<{
    rel: string;
    href: string;
    crossOrigin?: string;
    as?: string;
    fetchPriority?: string;
    type?: string;
  }> = [{
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous'
  }, {
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com'
  }, {
    rel: 'dns-prefetch',
    href: 'https://images.unsplash.com'
  }, {
    rel: 'preload',
    as: 'image',
    href: 'https://cdn.magicpatterns.com/uploads/34hBihuiP8ZCnzPLfTxr7K/1500-CLIENTE-SODDISFATTI-_6_.webp',
    fetchPriority: 'high'
  }];
  links.forEach(({
    rel,
    href,
    crossOrigin,
    as,
    fetchPriority,
    type
  }) => {
    if (head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
    const el = document.createElement('link');
    el.rel = rel;
    el.href = href;
    if (as) el.setAttribute('as', as);
    if (crossOrigin) el.crossOrigin = crossOrigin;
    if (type) el.type = type;
    if (fetchPriority) el.setAttribute('fetchpriority', fetchPriority);
    head.appendChild(el);
  });
})();
render(<App data-id="element-295" />, document.getElementById('root'));